import ComingSoon from "@/components/ComingSoon";

export default function AIAgents() {
  return (
    <ComingSoon
      area="agents"
      eyebrow="AI Agents · Opening Soon"
      title="Agents in service of life, not noise."
      body="Our AI Agents area will host council-aligned agents — for inventors, researchers, healers and editors. Each agent designed with transparency, plurality, and joy. Be among the first to test them."
      image="https://images.unsplash.com/photo-1782015941315-c879b97866de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGFydGlmaWNpYWwlMjBpbnRlbGxpZ2VuY2UlMjBnb2xkfGVufDB8fHx8MTc4MjA5NDc2NHww&ixlib=rb-4.1.0&q=85"
    />
  );
}
